import type { Flag, FlagComment } from '~/shared/api/data-ingestion-api/client'

export function getSortedComments(flag: Flag): FlagComment[] {
  const comments = flag.comments ?? []
  return [...comments].sort((a, b) => a.created_at.localeCompare(b.created_at))
}

export function getFlagCreator(flag: Flag): FlagComment | null {
  const sorted = getSortedComments(flag)
  return sorted.find((c) => c.type === 'flag') ?? sorted[0] ?? null
}

export function getFlagResolution(flag: Flag): FlagComment | null {
  const sorted = getSortedComments(flag)
  for (let i = sorted.length - 1; i >= 0; i--) {
    if (sorted[i].type === 'resolution') return sorted[i]
  }
  return null
}
